import { z } from 'zod';

export const forgotPasswordPostRequestSchema = z.object({
  client: z.string(),
  client_secret: z.string(),
  email: z.string(),
});
